import { useEffect, useState } from 'react';
import { DropdownMenu } from '../Menus/DropdownMenu';
import { CaseMilestone } from '../../../data/types';

type MilestoneDropdownProps = {
    className?: string;
    initialMilestoneId?: string;
    milestones?: CaseMilestone[];
    onMilestoneSelected?: (milestoneId?: string) => void;
    appearance?: 'outline' | 'filled-darker' | 'filled-lighter' | 'underline';
};
export const MilestoneDropdown = (props: MilestoneDropdownProps) => {
    const { className, initialMilestoneId, onMilestoneSelected, milestones, appearance='outline' } = props;

    //State
    const [selectedMilestoneId, setSelectedMilestoneId] = useState<string | undefined>(initialMilestoneId);

    //Logic
    const onOptionSelected = (option: string) => {
        if (option) {
            setSelectedMilestoneId(option);
            !!onMilestoneSelected && onMilestoneSelected(option);
        } else {
            setSelectedMilestoneId(undefined);
            !!onMilestoneSelected && onMilestoneSelected(undefined);
        }
    };
    const sortMilestones = (a: CaseMilestone, b: CaseMilestone) => {
        return (a.sortKey || 0) - (b.sortKey || 0);
    };
    
    useEffect(() => {
        if (!!initialMilestoneId) {
            const ms = milestones?.find((x) => x.milestoneId == initialMilestoneId);
            if (ms) {
                setSelectedMilestoneId(ms.milestoneId);
                !!onMilestoneSelected && onMilestoneSelected(ms.milestoneId);
            }
        }
    }, [initialMilestoneId, milestones?.length]);
    
    return (
        <>
            <DropdownMenu
                size='medium'
                className={className}
                initialValue={selectedMilestoneId}
                options={
                    milestones?.sort(sortMilestones).map((ms, idx) => ({
                        label: `#${(idx || 0) + 1} - ${ms.name}`,
                        value: ms.milestoneId || '',
                    })) || []
                }
                onOptionChanged={onOptionSelected}
                placeholder={'Select Milestone'}
                appearance={appearance}
                dataTestId='milestone-dropdown-menu'
            />
        </>
    );
};
